export function calcIcon(rankPercentage: number): string {
  if (rankPercentage >= 0 && rankPercentage <= 1) {
    return 'crown';
  } else if (rankPercentage > 1 && rankPercentage <= 5) {
    return 'crown';
  } else if (rankPercentage > 5 && rankPercentage <= 20) {
    return 'crown';
  } else if (rankPercentage > 20 && rankPercentage <= 40) {
    return 'medal';
  } else if (rankPercentage > 40 && rankPercentage <= 60) {
    return 'medal';
  } else if (rankPercentage > 60 && rankPercentage <= 80) {
    return 'medal';
  }
  return 'medal';
}

export function calcIconColor(rankPercentage: number): string {
  if (rankPercentage >= 0 && rankPercentage <= 1) {
    return '--game-trophy-gold-fill';
  } else if (rankPercentage > 1 && rankPercentage <= 5) {
    return '--game-trophy-silver-fill';
  } else if (rankPercentage > 5 && rankPercentage <= 20) {
    return '--game-trophy-bronze-fill';
  } else if (rankPercentage > 20 && rankPercentage <= 40) {
    return '--game-trophy-gold-fill';
  } else if (rankPercentage > 40 && rankPercentage <= 60) {
    return '--game-trophy-silver-fill';
  } else if (rankPercentage > 60 && rankPercentage <= 80) {
    return '--game-trophy-bronze-fill';
  }
  return '--game-trophy-default-fill';
}

export function calcMedalSource(rankPercentage: number, themeFolder: string): string {
  const goldMedal = `assets/images/${themeFolder}/gold.svg`;
  const silverMedal = `assets/images/${themeFolder}/silver.svg`;
  const bronzeMedal = `assets/images/${themeFolder}/bronze.svg`;
  const fourthMedal = `assets/images/${themeFolder}/4th.svg`;
  const fifthMedal = `assets/images/${themeFolder}/5th.svg`;
  const sixthMedal = `assets/images/${themeFolder}/6th.svg`;
  const defaultMedal = `assets/images/${themeFolder}/default-trophy.svg`;

  if (rankPercentage >= 0 && rankPercentage <= 1) {
    return goldMedal;
  } else if (rankPercentage > 1 && rankPercentage <= 5) {
    return silverMedal;
  } else if (rankPercentage > 5 && rankPercentage <= 20) {
    return bronzeMedal;
  } else if (rankPercentage > 20 && rankPercentage <= 40) {
    return fourthMedal;
  } else if (rankPercentage > 40 && rankPercentage <= 60) {
    return fifthMedal;
  } else if (rankPercentage > 60 && rankPercentage <= 80) {
    return sixthMedal;
  }
  return defaultMedal;
}
